import {SET_COUPONS} from "../constants/coupons";

const initialState = {
  list: []
};

const couponsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_COUPONS:
      return {
        ...state,
        list: action.list,
      };
    default:
      return state;
  }
};

export default couponsReducer;